// extracted by mini-css-extract-plugin
export default {"Container":"UploadFile_Container__UpIoC","File":"UploadFile_File__z60HR","Loading":"UploadFile_Loading__f3v92"};